import { FoDeparturePage } from './../fo-departure/fo-departure';
import { FoArrivalPage } from './../fo-arrival/fo-arrival';
import { FoInhousePage } from './../fo-inhouse/fo-inhouse';
import { FoInfoPage } from './../fo-info/fo-info';
import {FoInventoryPage} from './../fo-inventory/fo-inventory';
import {FoStatisticPage} from './../fo-statistic/fo-statistic';
import { Component  } from '@angular/core';
import { IonicPage, NavController, NavParams} from 'ionic-angular';
import { CheckoutPage } from './../checkout/checkout';
import { AuthProvider } from './../../providers/auth/auth';


/**
 * Generated class for the DashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {
  tabStatistic = FoStatisticPage;
  tabInfo = FoInfoPage;
  tabInhouse = FoInhousePage;
  tabArrival = FoArrivalPage;
  tabDeparture = FoDeparturePage;
  tabInventory = FoInventoryPage;
  tabCheckout = CheckoutPage;
  username = '';

  constructor(private auth: AuthProvider) {
    let info = this.auth.getUserInfo();
    this.username = info.username;
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad DashboardPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts